import React from 'react';

import { getGlobalStateUtils } from 'svs-utils/react';

var initialGlobalState = {
    jsonViewTool: { selectedTab: 0, tabs: [{ json: '' }] },
};
export var { GlobalStateProvider, useStateSlice } = getGlobalStateUtils(React, initialGlobalState);
